import React, { useState } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createEnhancedTheme } from './theme/enhancedTheme';
import EnhancedTremChain from './components/EnhancedTremChain';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const theme = createEnhancedTheme(isDarkMode);

  const handleThemeToggle = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <EnhancedTremChain 
        isDarkMode={isDarkMode} 
        onThemeToggle={handleThemeToggle} 
      />
    </ThemeProvider>
  );
}

export default App;
